import { cn } from "../../../lib/cn";
import { Button } from "../Button";

/**
 * Reusable empty-state component.
 * icon (React component) + title + description + single primary CTA (+ optional secondary).
 * Replaces the minimal NoDataFound pattern with context-rich guidance.
 */
export const EmptyState = ({
  icon: Icon,
  title,
  description,
  actionText,
  onAction,
  secondaryText,
  onSecondary,
  className,
  compact = false,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center bg-white rounded-xl border border-surface-border",
        compact ? "py-8 px-6" : "py-16 px-6",
        className
      )}
    >
      {Icon && (
        <div
          className={cn(
            "flex items-center justify-center rounded-full bg-surface/60 text-primary/60",
            compact ? "w-10 h-10 mb-3" : "w-14 h-14 mb-4"
          )}
        >
          {typeof Icon === "string" ? (
            <span className={compact ? "text-xl" : "text-2xl"}>{Icon}</span>
          ) : (
            <Icon className={compact ? "w-5 h-5" : "w-7 h-7"} />
          )}
        </div>
      )}
      <h3
        className={cn(
          "font-semibold text-primary",
          compact ? "text-sm mb-1" : "text-lg mb-2"
        )}
      >
        {title}
      </h3>
      {description && (
        <p
          className={cn(
            "text-mediumgrey max-w-sm mx-auto",
            compact ? "text-xs mb-4" : "text-sm mb-6"
          )}
        >
          {description}
        </p>
      )}
      {(actionText || secondaryText) && (
        <div className="flex items-center gap-3">
          {actionText && onAction && (
            <Button
              variant="filled"
              color="primary"
              size="md"
              className="font-semibold"
              onClick={onAction}
            >
              {actionText}
            </Button>
          )}
          {secondaryText && onSecondary && (
            <Button
              variant="transparent"
              color="primary"
              size="md"
              className="hover:text-secondary-dark"
              onClick={onSecondary}
            >
              {secondaryText}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
